import { createAction } from '@reduxjs/toolkit';

export const galleryUpdateId = createAction('gallery/updateId');
export const galleryUpdateUID = createAction('gallery/updateUid');
export const galleryUpdateSID = createAction('gallery/updateSid');
export const galleryUpdateIsAdded = createAction('gallery/updateIsAdded');
export const galleryUpdateIsActive = createAction('gallery/updateIsActive');

export const galleryStore = createAction('gallery/store');
export const galleryClear = createAction('gallery/clear');

export const galleryUpdateRequest = createAction('gallery/updateRequest');
export const galleryUpdateError = createAction('gallery/updateError');
export const galleryUpdateStore = createAction('gallery/updateStore');

export const galleryUpdateItems = createAction('gallery/updateItems');

export const galleryUpdateLayout = createAction('gallery/updateLayout');
export const galleryUpdateView = createAction('gallery/updateView');
export const galleryUpdateListView = createAction('gallery/updateListView');

export const galleryUpdateHeadingTitle = createAction('gallery/updateHeadingTitle');
export const galleryUpdateHeadingDescription = createAction('gallery/updateHeadingDescription');
export const galleryUpdateHeadingTextAlign = createAction('gallery/updateHeadingTextAlign');
export const galleryUpdateHeadingImage = createAction('gallery/updateHeadingImage');
export const galleryUpdateHeadingDivider = createAction('gallery/updateHeadingDivider');

export const galleryUpdateSectionIsBackground = createAction('gallery/updateSectionIsBackground');
export const galleryUpdateSectionTextColor = createAction('gallery/updateSectionTextColor');
export const galleryUpdateSectionBackgroundColor = createAction('gallery/updateSectionBackgroundColor');
export const galleryUpdateSectionOpacity = createAction('gallery/updateSectionOpacity');
export const galleryUpdateSectionIsFullWidth = createAction('gallery/updateSectionIsFullWidth');
export const galleryUpdateSectionShadow = createAction('gallery/updateSectionShadow');
export const galleryUpdateSectionShadowColor = createAction('gallery/updateSectionShadowColor');
export const galleryUpdateSectionPadding = createAction('gallery/updateSectionPadding');
export const galleryUpdateSectionMargin = createAction('gallery/updateSectionMargin');
export const galleryUpdateSectionBackgroundType = createAction('gallery/updateSectionBackgroundType');
export const galleryUpdateSectionBackgroundImage = createAction('gallery/updateSectionBackgroundImage');
export const galleryUpdateSectionGradientColor1 = createAction('gallery/updateSectionGradientColor1');
export const galleryUpdateSectionGradientColor2 = createAction('gallery/updateSectionGradientColor2');
export const galleryUpdateSectionGradientDirection = createAction('gallery/updateSectionGradientDirection');
export const galleryUpdateSectionGradientOffset = createAction('gallery/updateSectionGradientOffset');
export const galleryUpdateSectionBorder = createAction('gallery/updateSectionBorder');
export const galleryUpdateSectionBorderColor = createAction('gallery/updateSectionBorderColor');
export const galleryUpdateSectionShadowBorderColor = createAction('gallery/updateSectionShadowBorderColor');
export const galleryUpdateSectionShape = createAction('gallery/updateSectionShape');

export const galleryUpdateItemOpacity = createAction('gallery/updateItemOpacity');
export const galleryUpdateItemShadow = createAction('gallery/updateItemShadow');
export const galleryUpdateItemShadowColor = createAction('gallery/updateItemShadowColor');
export const galleryUpdateItemBorder = createAction('gallery/updateItemBorder');
export const galleryUpdateItemBorderColor = createAction('gallery/updateItemBorderColor');
export const galleryUpdateItemShape = createAction('gallery/updateItemShape');
